import { render } from "./LRecoveryForm.vue?vue&type=template&id=ff4d4ebe&ts=true"
import script from "./LRecoveryForm.vue?vue&type=script&lang=ts"
export * from "./LRecoveryForm.vue?vue&type=script&lang=ts"

import "./LRecoveryForm.vue?vue&type=style&index=0&id=ff4d4ebe&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__